<div class="buttons_container">  
    <div 
        class="custom-button-style"
        (click)="navigate('individual-users')">
            <p class="custom-button-text-title">
                {{languageService.Strings.buttons.button_individualUsers_title}}
            </p>
            <p>
                {{languageService.Strings.buttons.button_individualUsers_text}}
            </p>
    </div>

    <div 
        class="custom-button-style"
        (click)="navigate('corporate-users')">
            <p class="custom-button-text-title">
                {{languageService.Strings.buttons.button_corporateUsers_title}}
            </p>
            <p>
                {{languageService.Strings.buttons.button_corporateUsers_text}}
            </p>
    </div>

    <div 
        class="custom-button-style"
        (click)="navigate('analysis-count')">
            <p class="custom-button-text-title">
                {{languageService.Strings.buttons.button_analysisCount_title}}
            </p>
            <p>
                {{languageService.Strings.buttons.button_analysisCount_text}}
            </p>
    </div>
</div>